import { apiFetch } from "./client.js";
export const getNowPlaying = () => apiFetch("/spotify/now-playing");
export const playSpotify = () => apiFetch("/spotify/play", { method: "POST" });
export const pauseSpotify = () => apiFetch("/spotify/pause", { method: "POST" });
export const nextTrack = () => apiFetch("/spotify/next", { method: "POST" });
export const previousTrack = () => apiFetch("/spotify/previous", { method: "POST" });
//# sourceMappingURL=spotify.js.map